const paymentsTypes = {
    FETCH_PAYMENTS: 'FETCH_PAYMENTS',
    FETCH_CUSTOMER_PAYMENTS: 'FETCH_CUSTOMER_PAYMENTS',
    FETCH_PAYMENTS_START: 'FETCH_PAYMENTS_START',
    FETCH_PAYMENTS_BY_CUSTOMER_START: 'FETCH_PAYMENTS_BY_CUSTOMER_START',
    FETCH_PAYMENTS_BY_CUSTOMER: 'FETCH_PAYMENTS_BY_CUSTOMER',
}

export default paymentsTypes;
